import gql from 'graphql-tag';

export const GET_LENDER_ACTIVITY_SUMMARY = gql`
  query LenderRetailActivitySummary($input: LenderRetailActivityReportInput!) {
    lenderRetailActivity {
      summary(input: $input) {
        success
        error
        entity {
          creditApps
          requestedAmount
          approvedApps
          approvalRate
          fundedApps
          syndications
          countries {
            country
            creditApps
            requestedAmount
            approvedApps
            approvalRate
            fundedApps
            syndications
          }
        }
      }
    }
  }
`;
